import React from 'react'
import {Row, Grid} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { getMonthEvents } from './EventsProvider';
import TimetableContainer from './roomTimetable/TimetableContainer';
import moment  from 'moment';
import { SingleDatePicker} from 'react-dates';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import styled from 'styled-components';
import { GridLoader } from 'react-spinners';

const DateInputSpacer = styled.div`
  margin: 0;
`
const LoaderDiv = styled.div`
  display: flex;
  position: absolute;
  margin-top: 413px;
  left: 50%;
`

const FullDiv =  styled.div`
  width: 100%;
`
const ContactBoldDiv = styled.div`
    width: 100%;
    text-align: center;
    font-weight: 500;
    margin-top: 10px;
`
const ContactdDiv = styled.div`
    width: 100%;
    text-align: center;
`
const CalendarControls = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin: 17px 0 12px;

  @media (max-width: 560px) {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  }
`
const AvailabilityLegend = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 12px;
  color: #4d5668;
  font-size: 13px;
`
const LegendItem = styled.div`
  display: flex;
  align-items: center;
  line-height: 1;
`
const LegendSwatch = styled.span`
  width: 12px;
  height: 12px;
  display: inline-block;
  margin-right: 6px;
  background-color: ${props => props.backgroundColour};
  border-radius: 2px;
  border: 1px solid #4c6090;
`
const TextDiv = styled.div`
  width: 100%;
  margin-top: 20px;
  font-size: larger;
  text-align: center;
  font-weight:500;
`
const LogoImg = styled.img`
  width: 90%;
  margin-left: 10%;
`

class App extends React.Component {
  constructor () {
    super()
    this.state = {
      events: [
        {room: 1, bookings:[]},
        {room: 2, bookings:[]},
        {room: 3, bookings:[]},
        {room: 4, bookings:[]},
        {room: 5, bookings:[]}
    ],
    selectedDay:moment(),
    loading: true,
    day: moment().tz("Europe/London").startOf('day'),
    focused: true
    }
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount () {
    getMonthEvents(moment().startOf('month').format("YYYY-MM-DD"),(events) => {
      this.setState({
        events: events, 
        loading: false
        })
    })
  }

  handleChange(date) {
    if (!this.state.selectedDay.isSame(date,'month')) {
      this.setState({
        loading: true
        },
        getMonthEvents(moment(date).startOf('month').format("YYYY-MM-DD"),(events) => {
          this.setState({
            events: events, 
            loading: false
            })
        })
    );
    }
    this.setState({
      day: moment(date).tz("Europe/London").startOf('day'),
      selectedDay: date
    });
  }

  render () {
    return (
      <Grid>
        <Row>
          <FullDiv>
        <LogoImg src={"logo.jpg"} />
        <TextDiv> Room Bookings </TextDiv>
        </FullDiv>
        <ContactBoldDiv>To book an available room please contact us:  </ContactBoldDiv>
        <ContactdDiv>07902 262534</ContactdDiv>
    <ContactdDiv>superunisonstudios@gmail.com</ContactdDiv>
        </Row>
        <Row>
          <CalendarControls>
          <DateInputSpacer>
          <SingleDatePicker date={this.state.day} 
            onDateChange={date => this.handleChange(date)} 
            focused={this.state.focused} 
            onFocusChange={({ focused }) => this.setState({ focused })}
            isOutsideRange={r => false}
            displayFormat="DD MMM YYYY"
            numberOfMonths={1}
          />
    </DateInputSpacer>
    <AvailabilityLegend aria-label="Calendar key">
      <LegendItem><LegendSwatch backgroundColour="#4c6090" />Booked</LegendItem>
      <LegendItem><LegendSwatch backgroundColour="#ffffff" />Available</LegendItem>
    </AvailabilityLegend>
    </CalendarControls>
  </Row>
<Row>
    <LoaderDiv>
      <GridLoader
          color={'#4c6090'} 
        loading={this.state.loading} 
        />
        </LoaderDiv>

          <TimetableContainer events={this.state.events} day={this.state.day} />
</Row>
<Row>
  </Row>

      </Grid>
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js